import { Add, Remove } from '@mui/icons-material';
import { Box, Button, Divider, Grid, Paper, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Monitoramentos, RISR } from '../../../../services/api/reports/ReportsServicesRisr';

interface MonitoringRiseProps {
    dataRisr?: RISR;
    onDataChange: (data: Monitoramentos[]) => void;
}

export const MonitoringRisr = ({ dataRisr, onDataChange }: MonitoringRiseProps) => {
    
    const [data, setData] = useState<Monitoramentos[]>([{ tipo: '', destaque: '' }]);
    

    useEffect(() => {
        if (dataRisr?.monitoramentos && Object.keys(dataRisr.monitoramentos).length > 0) {
            setData(dataRisr.monitoramentos);
        }
    }, [dataRisr]);

    const handleAdd = () => {
        const newItem: Monitoramentos = { tipo: '', destaque: '' };
        setData(prevDataSteps => [...prevDataSteps, newItem]);
    };

    const handleRemove = () => {
        if (data.length > 1) {
            setData(prevDataSteps => prevDataSteps.slice(0, -1));
        }
    };

    const handleMonitoringChange = (index: number, fieldName: keyof Monitoramentos, value: string) => {
        const updatedData = [...data];
        updatedData[index][fieldName] = value;
        setData(updatedData);
        onDataChange(updatedData);
    };

    return (
        <Box>
            <Box padding={1}>
                <Grid container>
                    <Grid item xs={12} marginBottom={1}>
                        <Typography variant='h5'>Interpretação dos monitoramentos</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Remove />}
                            onClick={handleRemove}
                            disabled={data.length <= 1}
                        >
                            Remover
                        </Button>
                    </Grid>
                    <Grid item xs={6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Add />}
                            onClick={handleAdd}
                        >
                            Adicionar
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Box>
                {data.map((item, index) => (
                    <Box key={index} padding={1}>
                        <Box padding={1} component={Paper} variant='outlined' sx={{ borderRadius: '20px' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        InputLabelProps={{ shrink: true }}
                                        label='Tipo de Monitoramento'
                                        value={item.tipo}
                                        fullWidth
                                        onChange={(e) => handleMonitoringChange(index, 'tipo', e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        InputLabelProps={{ shrink: true }}
                                        label='Destaques'
                                        value={item.destaque}
                                        fullWidth
                                        onChange={(e) => handleMonitoringChange(index, 'destaque', e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
